import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { message } from '../util/messages/messages';
import parse from 'html-react-parser';
import { getTokenExpiredValidation, getTokenCookies } from './auth/auth.service';

const tokenKey = process.env.NEXT_PUBLIC_TOKEN ?? '';
const tokenRefreshKey = process.env.NEXT_PUBLIC_TOKEN_REFRESH ?? '';

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_API_URL,
});

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

function onRrefreshed(token: string): void {
  refreshSubscribers.map(callback => callback(token));
}

function addRefreshSubscriber(callback: (token: string) => void): void {
  refreshSubscribers.push(callback);
}

api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    let token = Cookies.get(tokenKey);
    if (token) {
      const tokenExpired = getTokenExpiredValidation(token);
      if (tokenExpired) {
        const tokenRefresh = Cookies.get(tokenRefreshKey);
        const tokenRefreshExpired = getTokenExpiredValidation(tokenRefresh ?? '');
        if (!tokenRefreshExpired) {
          if (!isRefreshing) {
            isRefreshing = true;
            await axios.post(`${process.env.NEXT_PUBLIC_BASE_API_URL}/atualizar`,  tokenRefresh )
              .then((response) => {
                isRefreshing = false;
                const newToken = response.data[0];
                Cookies.set(tokenKey, newToken);
                Cookies.set(tokenRefreshKey, response.data[1]);
                onRrefreshed(newToken);
              });
          }
          return new Promise((resolve) => {
            addRefreshSubscriber((newToken: string) => {
              if (config.headers) {
                config.headers.Authorization = `Bearer ${newToken}`;
              }
              resolve(config);
            });
          });
        }
      }
      if (config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError | { response: AxiosResponse | undefined; errorMessage: string; httpstatuscode: number }> => {
    const defaultMessage = 'Ocorreu um erro. Por favor, tente novamente.';
    let errorMessage = defaultMessage;
    let httpstatuscode = 500;

    const expirePrincipalToken = getTokenExpiredValidation(getTokenCookies("PRINCIPAL") ?? "");
    if (error.response) {
      if (error.response.status == 401) {
        errorMessage = message.userOrPasswordInvalid;
        httpstatuscode = error.response.status;
      } else if (expirePrincipalToken) {
        errorMessage = message.expiredSession;
        httpstatuscode = 401;
      }
    } else if (error.request) {
      if (error.code === 'ERR_NETWORK') {
        errorMessage = message.serverError;
        httpstatuscode = 503;
      }
    } else {
      errorMessage = defaultMessage;
    }

    return Promise.reject({ response: error.response, errorMessage: parse(errorMessage), httpstatuscode });
  }
);

function handleError(err: AxiosError | any): any {
  if (err.response && err.response.status === 401) {
    // refreshToken();
    console.log(err);
  }
  if (err.response?.data?.message) {
    // toast.error(err.response?.data?.message);
    return;
  }
  return err;
}

export default api;
